import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";
import React from "react";

const Weekoffslider = withStyles({
  root: {
    color: "#166ab3",
    height: 8,
    width: "64%",
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus,&:hover,&$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export default function CustomizedSlider(props) {
  return <Weekoffslider className="margin-right-16 margin-left-16 week-off-slider-new" aria-label="pretto slider" { ...props } />;
}
